export enum PoTypeEnum {
    P24 = 'P24',
    P40 = 'P40',
    P41 = 'P41',
    P56 = 'P56',
    P58 = 'P58'
}
